import { useQueryClient } from '@tanstack/react-query';
import { useProfile } from 'init/index';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { useMemo } from 'react';
import { useLoadCompanyConfiguration } from 'shared/hooks/use-load-company-configuration';
import { accountActions } from 'store/account/account.actions';

export const useSynchroniseIntegration = () => {
  const company = useCompanyConfiguration();
  const { refetchCompany } = useLoadCompanyConfiguration();
  const queryClient = useQueryClient();

  const {
    tp_accounting: {
      automatic_sync,
      can_synchronise_import,
      last_import_date,
      manual_import_possible_from,
      can_import_pdfs,
    },
  } = company;

  const profile = useProfile();

  const canSynchronize = useMemo(() => {
    if (manual_import_possible_from) {
      return new Date(manual_import_possible_from).getTime() < Date.now();
    }

    return !!can_synchronise_import;
  }, [can_synchronise_import, manual_import_possible_from]);

  const synchronize = () => {
    if (profile.isSuperAdmin || canSynchronize) {
      accountActions.syncIntegration({
        actionFailure: () => {
          refetchCompany();
        },
        callback: () => {
          queryClient.invalidateQueries({ queryKey: ['company-configuration'] });
        },
      });
    }
  };

  const synchronizePdfs = () => {
    accountActions.syncIntegrationPdfs();
  };

  return {
    synchronize,
    synchronizePdfs,
    canSynchronize,
    lastImportDate: last_import_date,
    nextPossibleSynchronizeDate: manual_import_possible_from,
    automaticSync: automatic_sync,
    canImportPdfs: can_import_pdfs,
  };
};
